// The order form's library pickers.
//
// The brand is chosen in step 1 of the same form, so a model list filtered on
// the server would be a page reload. Every card carries the enterprise it
// belongs to instead, and this hides the ones that are somebody else's the
// moment a brand is picked. Records with no enterprise are global — they belong
// to everyone and are never hidden.
//
// Hiding rather than disabling: a shelf of greyed-out cards from other brands
// is noise in a form whose whole point is one question at a time.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["brand", "item", "group", "none"]

  connect() {
    this.filter()
  }

  filter() {
    const brand = this.hasBrandTarget ? this.brandTarget.value : ""

    this.itemTargets.forEach((item) => {
      const owner = item.dataset.enterprise
      const global = !owner
      const mine = brand && owner === brand
      const show = global || mine || !brand
      item.hidden = !show
      // A card that has just been hidden must not still be submitted.
      if (!show) {
        const box = item.querySelector("input[type=checkbox]")
        if (box) box.checked = false
      }
    })

    // Tell each picker whether it has anything left to offer, so an empty
    // library says so instead of looking broken.
    this.groupTargets.forEach((group) => {
      const visible = Array.from(group.querySelectorAll("[data-order-library-target='item']"))
        .some((item) => !item.hidden)
      const none = group.querySelector("[data-order-library-target='none']")
      if (none) none.hidden = visible
    })
  }
}
